<template>
  <body is="app-layout" :authenticated="!!$store.state.user">
    <router-view></router-view>
  </body>
</template>

<script>
  import AppLayout from 'package-common-vuejs/src/layouts/AppLayout';
  import {AppMixin} from '../mixins/app-mixin';

  export default {
    mixins: [AppMixin],
    components: {
      AppLayout,
    }
  }
</script>

<style type="text/css" lang="css">
  .table > tbody > tr  > td {
    vertical-align: top;
  }
  .table > tbody > tr  > td.centered {
    vertical-align: middle;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/App.vue